import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2135aeda"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "worp" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "拉流地址：", -1))
const _hoisted_3 = { class: "item" }
const _hoisted_4 = { class: "item flex" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "but" }
const _hoisted_7 = { class: "text" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text_span" }, "拉流地址支持：直播流 rtmp，rtsp，hls等，点播流 hls，mp4等，单次最长拉流时长不超过24小时（超过后自动终止）。", -1))
const _hoisted_9 = { class: "content" }
const _hoisted_10 = ["data-clipboard-text"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "model_title" }, "拉流直播使用帮助", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "model_body" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "什么是拉流直播？"),
  /*#__PURE__*/_createElementVNode("p", null, "  管理员通过地址拉流的方式将外部视频源推送到控制平台，并进行直播和控制。"),
  /*#__PURE__*/_createElementVNode("h3", null, "支持什么格式？"),
  /*#__PURE__*/_createElementVNode("p", null, "  拉流地址基本支持所有的直播流和点播流，直播地址包括rtmp、rtsp、hls等，点播地址包括hls、MP4、flv等。"),
  /*#__PURE__*/_createElementVNode("h3", null, "如何操作？"),
  /*#__PURE__*/_createElementVNode("p", null, "  输入拉流地址，点击开始直播后，即可进行直播。直播过程中拉流地址不可修改，只有点击停止直播后才可修改。"),
  /*#__PURE__*/_createElementVNode("h3", null, "如何获取直播拉流地址？"),
  /*#__PURE__*/_createElementVNode("p", null, "  直播拉流地址通常是直播视频播放地址（不是网页地址），需要向管理员索取。"),
  /*#__PURE__*/_createElementVNode("h3", null, "如何获取点播拉流地址？"),
  /*#__PURE__*/_createElementVNode("p", null, "  以为例，视频存储在视频库中都有一个下载地址，只需要将这个下载地址填入拉流地址中即可直播此段视频。")
], -1))

import { getCurrentInstance, onMounted, onUnmounted, ref } from 'vue';
import { Input, Button, Modal, message, Table, notification } from 'ant-design-vue';
import { DownOutlined } from '@ant-design/icons-vue';
import http from '@/api';
import router from '@/router';
import ClipboardJS from 'clipboard';
import { useDebounce } from '@/hooks/useDebounce'; //防抖
import { PullLive, HisData } from './liveMode';
import { getToken } from '@/plugins/cookie';
import EventBus from '@/components/EventBus';
import { onExport } from '@/components/CExport'; //导出
import https from '@/api/exportList';


export default /*#__PURE__*/_defineComponent({
  __name: 'PullLive',
  setup(__props) {

const studioId = router.currentRoute.value.params.studioId;
const aInput = Input;
const aButton = Button;
const aModal = Modal;
const aTable = Table;
const visible = ref(false);
const onHelp = () => {
  visible.value = !visible.value;
};

// 获取 拉流直播 信息
const pullStatusDisabled = ref(false);
const pullState = ref<PullLive>({
  pull_url: '',
  status: 0,
  duration: 0,
});
const getPullLive = () => {
  const data = {
    studio_id: studioId,
  };
  http.liveMode.getPullLive({ params: data }).then((res) => {
    pullState.value = res.data.data;
    pullState.value.duration = res.data.data.duration ? res.data.data.duration : 0;
    res.data.data.status === 1 ? (pullStatusDisabled.value = true) : (pullStatusDisabled.value = false);
    if (pullState.value.duration) {
      onTimer(0);
    }
  });
};
getPullLive();
// 开始 结束 直播
const editPullLive = useDebounce((status: number) => {
  if (status === 1) {
    if (pullState.value.pull_url != '') {
      const data = {
        pull_url: pullState.value.pull_url,
        status: status,
        studio_id: studioId,
      };
      http.liveMode
        .editPullLive(data)
        .then((res) => {
          pullState.value.status = 1;
          pullStatusDisabled.value = true;
          message.success(res.data.message);
        })
        .catch((err) => {
          pullStatusDisabled.value = false;
          pullState.value.pull_url = '';
          message.error(err.data.error);
        });
    } else {
      message.info('你还没有输入拉流地址！');
    }
  } else {
    const data = {
      pull_url: '',
      status: status,
      studio_id: studioId,
    };
    http.liveMode
      .editPullLive(data)
      .then((res) => {
        pullState.value.pull_url = '';
        pullState.value.status = 0;
        pullStatusDisabled.value = false;
        message.success(res.data.message);
      })
      .catch((err) => {
        message.error(err.data.error);
      });
  }
});

const historyArr = ref<HisData[]>([]);
const loading = ref(false);
// 获取历史记录
const getPullHistory = () => {
  const data = { studio_id: studioId, export: 0 };
  onShowHistory();
  loading.value = true;
  if (showHistory.value) {
    http.liveMode
      .getPullHistory({ params: data })
      .then((res) => {
        loading.value = false;
        historyArr.value = res.data.data ? res.data.data : '';
      })
      .catch((err) => {
        message.error(err.data.error);
      });
  }
};
// 计时器
const timer = ref();
const timing = ref('00:00:00');
const onTimer = (type: number) => {
  function addZero(i: number) {
    return i < 10 ? `0${i}` : i;
  }
  let timeData = type ? 0 : pullState.value.duration;
  timer.value = setInterval(() => {
    (timeData as number)++;
    const hour = parseInt((((timeData as number) / (60 * 60)) % 24).toString(), 10);
    const minute = parseInt((((timeData as number) / 60) % 60).toString(), 10);
    const second = parseInt(((timeData as number) % 60).toString(), 10);
    timing.value = `${addZero(hour)}:${addZero(minute)}:${addZero(second)}`;
  }, 1000);
};

const pullStatus = (data: any) => {
  if (data.status === '1') {
    onTimer(1);
  } else {
    clearInterval(timer.value);
  }
};
EventBus.on('pullStatus', pullStatus);

// 历史记录导出
const { proxy }: any = getCurrentInstance();
const token = getToken();
const corn = ref(1);
const messageTip = ref();
const exportData = useDebounce((type: number) => {
  const data = {
    studio_id: studioId,
    export: type,
    is_cron_download: corn.value,
  };
  https
    .live_pull_stream_list({ params: data })
    .then((res: any) => {
      messageTip.value = res.data.message;
      openNotificationWithIcon('success');
    })
    .catch((res: any) => {
      messageTip.value = res.data.error
      openNotificationWithIcon('error');
    });
});
// 导出成功时发出通知
const openNotificationWithIcon = (type: string) => {
  notification[type]({
    message: messageTip.value,
   duration: 5,
  });
};

const showHistory = ref(false);
const onShowHistory = () => {
  showHistory.value = !showHistory.value;
};

onUnmounted(() => {
  EventBus.off('pullStatus', pullStatus);
  clearInterval(timer.value);
});

const columns = [
  {
    title: '地址',
    dataIndex: 'pull_url',
    key: 'pull_url',
    width: '50%',
    ellipsis: true,
  },
  {
    title: '',
    slots: { customRender: 'text' },
    width: 50,
  },
  {
    title: '',
    slots: { customRender: 'use' },
    width: 50,
  },
  {
    title: '拉流时间',
    dataIndex: 'start_at',
    key: 'start_at',
    width: 180,
    ellipsis: true,
  },
];

const copyText = (btns: string) => {
  const ClipboardJSObj = new ClipboardJS(btns);
  ClipboardJSObj.on('success', (e) => {
    message.destroy();
    message.info('复制成功');
    e.clearSelection();
  });
  ClipboardJSObj.on('error', () => {
    message.destroy();
    message.info('复制失败');
  });
};

const usePullUrl = (url: string) => {
  pullState.value.pull_url = url;
};

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(aInput), {
          value: pullState.value.pull_url,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((pullState.value.pull_url) = $event)),
          readonly: pullStatusDisabled.value
        }, null, 8, ["value", "readonly"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", null, [
          (pullState.value.status === 0)
            ? (_openBlock(), _createBlock(_unref(aButton), {
                key: 0,
                class: "primary_but",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(editPullLive)(1)))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_svg_icon, {
                    "icon-class": "start_live",
                    class: "icon_start"
                  }),
                  _createTextVNode(" 开始直播 ")
                ]),
                _: 1
              }))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_unref(aButton), {
                  class: "stop_live",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(editPullLive)(2)))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_svg_icon, {
                      "icon-class": "stop_live",
                      class: "icon_start show"
                    }),
                    _createVNode(_component_svg_icon, {
                      "icon-class": "stoping_live",
                      class: "icon_start show2"
                    }),
                    _createTextVNode(" " + _toDisplayString(timing.value), 1)
                  ]),
                  _: 1
                })
              ]))
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_unref(aButton), {
            type: "link",
            class: "but_help",
            onClick: getPullHistory
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 使用记录 ")
            ]),
            _: 1
          }),
          _createTextVNode(" |"),
          _createVNode(_unref(aButton), {
            type: "link",
            class: "but_help",
            onClick: onHelp
          }, {
            default: _withCtx(() => [
              _createTextVNode("使用帮助")
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_svg_icon, { "icon-class": "icon_blue" }),
        _hoisted_8
      ])
    ]),
    _createVNode(_unref(aModal), {
      visible: showHistory.value,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((showHistory).value = $event)),
      width: "720px",
      title: "拉流地址",
      centered: ""
    }, {
      footer: _withCtx(() => [
        _createVNode(_unref(aButton), {
          key: "back",
          onClick: onShowHistory
        }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        }),
        _createVNode(_unref(aButton), {
          key: "submit",
          type: "primary",
          disabled: historyArr.value.length === 0,
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(exportData)(1)))
        }, {
          default: _withCtx(() => [
            _createTextVNode("导出")
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_unref(aTable), {
            columns: columns,
            "data-source": historyArr.value,
            pagination: false,
            rowKey: "id",
            loading: loading.value
          }, {
            text: _withCtx(({ record }) => [
              _createElementVNode("span", {
                class: "copy",
                "data-clipboard-text": record.pull_url,
                onClick: _cache[4] || (_cache[4] = ($event: any) => (copyText('.copy')))
              }, "复制", 8, _hoisted_10)
            ]),
            use: _withCtx(({ record }) => [
              _createElementVNode("span", {
                class: "copy",
                onClick: ($event: any) => (usePullUrl(record.pull_url))
              }, "使用", 8, _hoisted_11)
            ]),
            _: 1
          }, 8, ["data-source", "loading"])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_unref(aModal), {
      visible: visible.value,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((visible).value = $event)),
      width: "700px",
      centered: "",
      footer: null
    }, {
      default: _withCtx(() => [
        _hoisted_12,
        _hoisted_13
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})